/* unplugin-vue-components disabled */import script from "./XsollaNativePriceFields.vue?vue&type=script&setup=true&lang=ts"
export * from "./XsollaNativePriceFields.vue?vue&type=script&setup=true&lang=ts"

import "./XsollaNativePriceFields.vue?vue&type=style&index=0&id=22657e7c&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22657e7c"]])

export default __exports__